
import React from "react";
import img1 from "./imgs/C8.jpg";
// import img2 from "./imgs/MCURE.jpg";
import img3 from "./imgs/17.M-Cure 8-c.jpg";
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../../../locales/config";
import img1en from "./imgs/C8.jpg";
import img2en from "./imgs/MC8.jpeg";
import img3en from "./imgs/16-M-Cure 8.jpg";

export function MCure8() {

    const lang = LOCALES_HELPER.getLan();

    return (
        <>
            {lang === DEFAULT_LOCALE
                ? <>
                    <img className="product-img" src={img3}/>
                    <img className="product-img" src={img1}/>

                </>
                : <>
                    <img className="product-img" src={img1en}/>
                    <img className="product-img" src={img2en}/>
                    <img className="product-img" src={img3en}/>
                </>
            }
        </>
    )
}